export const REQUEST = "REQUEST";
export const SUCCESS = "SUCCESS";
export const ERROR = "ERROR";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
